import * as React from "react";

const MenuInactive: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="currentColor">
            <g fill="none" fillRule="evenodd">
                <rect width="30" height="30" rx="2" />
                <path
                    fill="#00205B"
                    fillRule="nonzero"
                    d="M24.286 9.265A.72.72 0 0 0 25 8.54V6.726A.72.72 0 0 0 24.286 6H5.714A.72.72 0 0 0 5 6.726V8.54c0 .4.32.725.714.725h18.572Zm0 7.257a.72.72 0 0 0 .714-.726v-1.814a.72.72 0 0 0-.714-.726H5.714a.72.72 0 0 0-.714.726v1.814c0 .4.32.726.714.726h18.572Zm0 7.256a.72.72 0 0 0 .714-.726v-1.814a.72.72 0 0 0-.714-.726H5.714a.72.72 0 0 0-.714.726v1.814c0 .4.32.726.714.726h18.572Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(MenuInactive);
